import { ApolloError } from '@apollo/client';

/** For mutations whose forms show their own errors; without it the global notification link adds a duplicate toast. */
export const INLINE_ERROR_MUTATION_OPTIONS = {
  errorPolicy: 'none',
  context: { notifications: { preventErrorNotification: true } },
} as const;

export interface NovaGroupError {
  code: string;
  message: string;
}

/** The BFF forwards ai-service Nova group error codes as a top-level `errorCode` on each GraphQL error. */
export function getNovaGroupError(error: unknown): NovaGroupError | undefined {
  if (!(error instanceof ApolloError)) return undefined;
  const [graphQLError] = error.graphQLErrors as ReadonlyArray<{ message: string; errorCode?: unknown }>;
  return typeof graphQLError?.errorCode === 'string'
    ? { code: graphQLError.errorCode, message: graphQLError.message }
    : undefined;
}
